<template>
  <div>
    <panier></panier>
    <v-form v-model="valid" ref="mainForm" class="mt-6">
      <opq-catalogue
        code="paiement-mode"
        v-model="sasReconnaissanceDeFormation.modeDePaiement"
        :code-filter="sas.modesDePaiementsAccessibles"
        :live="liveSasReconnaissanceFormation(10741)"
      ></opq-catalogue>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import Panier from "@/components/FormParts/Panier"
import { mapActions } from "vuex"
export default {
  mixins: [CataloguesHelper, FormSimple],
  props: {
    sas: { type: Object, required: true }
  },
  computed: {
    sasReconnaissanceDeFormation() {
      return this.sas.sasReconnaissanceDeFormation
    }
  },
  components: {
    Panier
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    liveSasReconnaissanceFormation(cle) {
      return { endpoint: "/sas-reconnaissance-formation/", cle: cle, fileId: this.sasReconnaissanceDeFormation.id }
    }
  }
}
</script>

<style>
</style>